import { NextSeo } from 'next-seo';
import Breadcrumb from '@/components/breadcrumb';
import LayoutBase from '@/components/layout-base';
import contentLayoutBaseData from '@/content/content-layout-base-data';
import ContentRegistrationPage from '@/content/content-registration-page';
import i18nMessagesLoad from '@/lib/i18n-messages-load';
import { localizationContextFromGetStaticPropsContext } from '@/lib/localization-contenxt';
import revalidateAfter from '@/lib/revalidate-after';
import type { NextPageWithLayout, NextGetStaticProps } from '../_app';

type RegistrationPageProps = {};

const RegistrationPage: NextPageWithLayout<RegistrationPageProps> = () => {
  const pageTitle = 'Registrace';

  return (
    <>
      <NextSeo title={pageTitle} />

      <main className='content-container'>
        <Breadcrumb className='py-4'>
          <Breadcrumb.Item href='/registrace' isCurrenctPage={true} position={1}>
            {pageTitle}
          </Breadcrumb.Item>
        </Breadcrumb>
        <h1 className='heading-page'>{pageTitle}</h1>
        <ContentRegistrationPage />
      </main>
    </>
  );
};

RegistrationPage.displayName = 'RegistrationPage';

RegistrationPage.getLayout = (page) => {
  return <LayoutBase>{page}</LayoutBase>;
};

export default RegistrationPage;

export const getStaticProps: NextGetStaticProps<RegistrationPageProps> = async (getStaticPropsContext) => {
  const localizationContext = localizationContextFromGetStaticPropsContext(getStaticPropsContext);
  const intlMessages = await i18nMessagesLoad(localizationContext);
  const layoutData = await contentLayoutBaseData(localizationContext);

  return {
    props: {
      intlMessages,
      layoutData,
    },
    revalidate: revalidateAfter('1h'),
  };
};
